import React from "react";

const ChevronLeftIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.74742 6.65848C3.41753 6.28145 3.41753 5.71849 3.74743 5.34147L6.95933 1.67074C7.14117 1.46292 7.45705 1.44187 7.66487 1.62371C7.87269 1.80555 7.89375 2.12143 7.7119 2.32925L4.5 5.99997L7.71191 9.67074C7.89375 9.87856 7.87269 10.1944 7.66487 10.3763C7.45705 10.5581 7.14117 10.5371 6.95933 10.3292L3.74742 6.65848Z"
        fill="#44536A"
      />
    </svg>
  );
};

export default ChevronLeftIcon;
